var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Asignar Barra de Acciones","value":true},on:{"close-modal":_vm.closeModal}},[_c('resource-action-form',{attrs:{"code-project":_vm.codeProject,"resource-id":_vm.id,"resource-name":_vm.name}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73686370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/page-resource-action.vue
// module id = 906
// module chunks = 39